import isArray from 'lodash/isArray'

import { User } from '@/Components/Pages/Accounts/types'

export const transformUserKeysForDatabase = ({
  roleIds,
  passwordConfirmation,
  firstName,
  lastName,
  ...user
}: Partial<User>) => ({
  ...user,
  first_name: firstName,
  last_name: lastName,
  role_ids: isArray(roleIds) ? roleIds : [roleIds],
  password_confirmation: passwordConfirmation
})
